import color from './color';
import radius from './radius';
import border from './border';
import typography from './typography';

const button = {
  primary: {
    background: color.primary,
    fontWeight: typography.fontWeight.default,
    border: border.default,
    borderColor: color.primary,
    radius: radius.small,
    color: color.white,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    fontSize: typography.fontSize.medium,
    textOverflow: 'ellipsis',
    shadow: '0px 0px 30px rgba(42, 0, 79, 0.1)',
  },
  secondary: {
    background: color.grey7,
    fontWeight: typography.fontWeight.default,
    border: border.default,
    borderColor: color.grey7,
    radius: radius.small,
    fontSize: typography.fontSize.medium,
    color: color.white,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    shadow: '0px 0px 30px rgba(42, 0, 79, 0.1)',
  },
  outLine: {
    background: 'transparent',
    fontWeight: typography.fontWeight.default,
    radius: radius.small,
    fontSize: typography.fontSize.medium,
    color: color.grey3,
    border: border.default,
    borderColor: color.grey3,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    shadow: '0px 0px 30px rgba(42, 0, 79, 0.1)',
  },
  text: {
    borderBottom: border.primary,
    padding: '0 5px 3px',
    color: color.black,
    fontWeight: typography.fontWeight.bold,
    textDecoration: 'none',
    cursor: 'pointer',
    active: {
      transform: 'none',
      boxShadow: 'none',
      color: color.primary,
    },
  },
}

export default button;
export {button}
